<mat-dialog-content>
  <lemon-dialog-header>
    {{ 'lasku.peruuta-maksumerkinta-dialog.otsikko' | translate | async }}
  </lemon-dialog-header>

  <p style="margin: 3em 3em 2em 3em">{{ 'lasku.peruuta-maksumerkinta-dialog.teksti' | translate | async }}</p>
</mat-dialog-content>

<mat-dialog-actions style="margin: 30px; margin-top: 12.5px; justify-content: center">
  <app-secondary-button mat-dialog-close actionId="Peru maksumerkintä dialog: peruuta">{{ 'yleiset.ei' | translate | async }}</app-secondary-button>
  <app-primary-button (click)="peru()" [focusRegionStart]="true" actionId="Peru maksumerkintä dialog: Vahvista">
    {{ 'yleiset.kylla' | translate | async }}
  </app-primary-button>
</mat-dialog-actions>
